import React, { useState, useEffect } from "react";
import axios from "axios";
// import US500 from "../assets/Coin/US500.svg";
// import US100 from "../assets/Coin/US100.svg";
// import UK100 from "../assets/Coin/UK100.svg";
// import DXY from "../assets/Coin/DXY.svg";
// import USOIL from "../assets/Coin/USOIL.svg";
// import XAU from "../assets/Coin/XAU.svg";
// import XAG from "../assets/Coin/XAG.svg";
// import XNG from "../assets/Coin/XNG.svg";

const style = {
  tableData: "text-[12px] text-[#f2f2f2] font-poppins font-normal py-2 px-10",
  tableContainer: "h-full overflow-y-auto scrollbar-hide",
  stickyHeader: "sticky top-0 bg-black z-10"
};

// Add this CSS to your global stylesheet or in a CSS-in-JS solution
const globalStyles = `
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  .scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
`;

// Inject the styles into the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = globalStyles;
document.head.appendChild(styleSheet);

const LiveTrade = ({ tradeData }) => {
  const [pnlValues, setPnlValues] = useState([]);

  const filteredArrays =
    tradeData &&
    tradeData.filter(
      (innerArray) => innerArray[7] === "Approved"
    );

  useEffect(() => {
    const fetchPnlValues = async () => {
      const promises = filteredArrays.map(async (dataItem) => {
        const pnlValue = await getPnlValue(dataItem[3], dataItem[1], dataItem[4]);
        return pnlValue;
      });
      const results = await Promise.all(promises);
      setPnlValues(results);
    };

    if (filteredArrays && filteredArrays.length > 0) {
      fetchPnlValues();
    }
  }, [tradeData,filteredArrays]);

  // const getSymbolIcon = (symbol) => {
  //   switch (symbol) {
  //     case "US500":
  //       return US500;
  //     case "US100":
  //       return US100;
  //     case "UK100":
  //       return UK100;
  //     case "DXY":
  //       return DXY;
  //     case "USOIL":
  //       return USOIL;
  //     case "XAU/USD":
  //       return XAU;
  //     case "XAG/USD":
  //       return XAG;
  //     case "XNG/USD":
  //       return XNG;
  //     default:
  //       return US500;
  //   }
  // }

  const getPnlValue = async (buy_value, ticker, quantity) => {
    let data = JSON.stringify({
      ticker: ticker,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://server.anshfintech.com/api/admin/ticker/ticker-data",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios
      .request(config)
      .then((response) => {
        const tickerPrice = response.data.data.price;
        const pnlValue = (tickerPrice - buy_value) * quantity;
        return pnlValue.toFixed(2);
      })
      .catch((error) => {
        console.log(error);
        return 0;
      });
  }

  return (
    <div className="mb-4 bg-gradient-to-tl from-[#FEF35A99]/90 via-[#FFFFFF]/20 to-[#FEF35A99]/10 p-[1px] rounded-[12px] md:rounded-[26px] shadow-custom-inner-high backdrop-blur-custom bg-black max-h-40">
      <div className="flex flex-col max-h-40 bg-gradient-to-b from-[#000000]/80 from-80% via-[#000000] via-80% to-[#000000] to-20% rounded-[12px] md:rounded-[26px] text-white shadow-custom-inner-high backdrop-blur-custom bg-black overflow-hidden">
        <div className="px-4 md:px-8 flex flex-row items-center leading-5 text-sm text-[#ffffff] font-normal md:text-base py-2">
          <div className="bg-[#E43D3D] w-3 h-3 md:w-4 md:h-4 rounded-full mr-2 animate-blink"></div>
          Live Trade
        </div>
        
        {!filteredArrays || filteredArrays.length === 0 ? (
          <div className="flex items-center justify-center flex-1">
            <span className="text-white text-lg py-10">
              No Live Trades!
            </span>
          </div>
        ) : (
          <div className="flex flex-col max-h-28">
            <table className="w-full table-auto">
              <thead className={style.stickyHeader}>
                <tr className="border-b border-[#818CEE]/20">
                  <th className="text-left px-10 py-2 text-[14px] font-medium text-white">
                    SYMBOL
                  </th>
                  <th className="text-left px-6 py-2 text-[14px] font-medium text-white">
                    PNL VALUE
                  </th>
                </tr>
              </thead>
            </table>
            <div className={style.tableContainer}>
              <table className="w-full table-auto">
                <tbody>
                  {filteredArrays.map((dataItem, index) => (
                    <tr
                      key={index}
                      className="border-b border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black"
                    >
                      <td className={style.tableData}>
                        <div className="flex gap-2">
                          {dataItem[1]}
                        </div>
                      </td>
                      <td 
                        className={`${style.tableData} ${
                          pnlValues[index] > 0
                            ? 'text-[#18b13f]'
                            : pnlValues[index] < 0
                            ? 'text-[#eb323f]'
                            : 'text-[#f2f2f2]'
                        }`}
                      >
                        <div className="flex gap-2">
                          {pnlValues[index]}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveTrade;
